import { render } from "./SurveyPage.vue?vue&type=template&id=55888f91&scoped=true"
import script from "./SurveyPage.vue?vue&type=script&lang=js"
export * from "./SurveyPage.vue?vue&type=script&lang=js"

import "./SurveyPage.vue?vue&type=style&index=0&id=55888f91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55888f91"]])

export default __exports__